var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L10.5669 15.8063C10.3229 16.0646 9.92714 16.0646 9.68306 15.8063L7 12.9676M23 12C23 18.0751 18.0751 23 12 23C11.317 23 10.6486 22.9378 10 22.8186C5.24143 21.9445 3.44435 19.4484 2.5 18C1.99629 17.2278 1 15.5 1 12C1 11.1401 1.09868 10.3031 1.28533 9.5C1.68727 7.77052 2.5 5 6 2.5C6.47004 2.16426 8.5 1 12 1C18.0751 1 23 5.92487 23 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.419ca419993a2358906460efe57d996f.svg";
export { ForwardRef as ReactComponent };